{
  "GENERAL_SETTINGS": {
    "TITLE": "Kontoeinstellungen",
    "SUBMIT": "Einstellungen aktualisieren",
    "BACK": "Zurück",
    "DISMISS": "Verwerfen",
    "UPDATE": {
      "ERROR": "Einstellungen konnten nicht aktualisiert werden, versuchen Sie es erneut!",
      "SUCCESS": "Kontoeinstellungen erfolgreich aktualisiert"
    },
    "FORM": {
      "ERROR": "Bitte Formularfehler korrigieren",
      "GENERAL_SECTION": {
        "TITLE": "Allgemeine Einstellungen",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Account ID",
        "NOTE": "Diese ID ist erforderlich, wenn Sie eine API-basierte Integration erstellen"
      },
      "NAME": {
        "LABEL": "Kontobezeichnung",
        "PLACEHOLDER": "Ihr Kontoname",
        "ERROR": "Bitte geben Sie einen gültigen Kontonamen ein"
      },
      "LANGUAGE": {
        "LABEL": "Sprache",
        "PLACEHOLDER": "Ihr Kontoname",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Eingehende E-Mail-Domain",
        "PLACEHOLDER": "Die Domain, von der E-Mails empfangen werden",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Support-E-Mail",
        "PLACEHOLDER": "Die Support-E-Mail Ihres Unternehmens",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Anzahl der Tage, nach denen ein Ticket automatisch geschlossen wird, wenn keine Aktivität erfolgt",
        "PLACEHOLDER": "30",
        "ERROR": "Bitte geben Sie eine gültige Dauer für die automatische Auflösung ein (mindestens 1Tag und maximal 999Tage)",
        "NOTE": "Anzahl der Inaktivitätsstunden, nach denen eine offene Unterhaltung automatisch gelöst wird."
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Konversationskontinuität mit E-Mails ist für Ihr Konto aktiviert.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Sie können jetzt E-Mails in Ihrer benutzerdefinierten Domäne empfangen."
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Anzahl der Tage, nach denen eine leere Unterhaltung ohne Aktivität automatisch gelöst werden soll",
        "PLACEHOLDER": "nie",
        "ERROR": "Bitte geben Sie eine gültige Dauer für die automatische Lösung leerer Unterhaltungen ein (mindestens 1 Tag und höchstens 999 Tage)"
      },
      "PHONE": {
        "TITLE": "PBX-Einstellungen",
        "NOTE": "Konfigurieren Sie die Verbindung zu Ihrer PBX für Telefonanrufe",
        "SIP_HOST": {
          "LABEL": "SIP-Domäne"
        },
        "DIALING_MODE": {
          "LABEL": "Wählmodus",
          "MODES": {
            "direct": "Direkt – Anruf wird sofort beim Klicken auf den Telefonlink gewählt",
            "indirect": "Indirekt – Telefonnummer wird im Eingabefeld des Telefon-Widgets vorbereitet"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Zugriff auf Anrufaufzeichnungen",
          "MODES": {
            "admin_only": "Nur Administratoren",
            "admin_and_assigned_agent": "Administratoren und zugewiesener Agent",
            "inbox_members": "Alle Agenten mit Posteingangszugriff"
          }
        }
      },
      "EMAIL": {
        "TITLE": "E-Mail-Einstellungen",
        "NOTE": "Ändert das Verhalten von E-Mail-Posteingängen"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Anzeigemodus für Unterhaltungs-Zeitstempel",
        "MODES": {
          "both": "Erstellung und letzte Aktivität",
          "last_activity_only": "Nur letzte Aktivität",
          "last_customer_message": "Letzte Kundennachricht"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Domänen mit niedriger Reputation blockieren"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Ursprüngliche Nachricht in Antwort auf die E-Mail einbeziehen"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Neue Unterhaltung automatisch lösen"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Neue E-Mail-Unterhaltung automatisch in den Posteingang des Roboters verschieben, der die Bestellungen des Kontakts bearbeitet hat"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Erweiterte Labels – längere Label-Namen mit größerer Popup-Oberfläche erlauben"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent – Unterhaltung automatisch dem Agenten zuweisen, der die letzte Antwort erstellt hat"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Modus der Push-Benachrichtigungen",
        "MODES": {
          "all_inboxes": "Alle Posteingänge – Benachrichtigungen für alle Kanaltypen senden",
          "chat_only": "Nur Chat – Benachrichtigungen nur für Nicht-E-Mail-Kanäle senden"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Umschalten der Signatur bei gesendeten Nachrichten erlauben"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Agenten-Chat-Status auf Wallboard anzeigen"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Vollständige Anhangsnamen ohne Abschneiden anzeigen"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Passwort-Anmeldung",
        "MODES": {
          "allowed_for_all": "Für alle Benutzer erlaubt",
          "allowed_for_agents_only": "Nur für Agenten erlaubt (Administratoren müssen OAuth verwenden)",
          "password_login_disabled": "Deaktiviert – nur OAuth"
        }
      }
    },
    "LEARN_MORE": "Mehr erfahren",
    "PAYMENT_PENDING": "Ihre Zahlung steht noch aus. Um diese Software weiter zu verwenden, aktualisieren Sie bitte Ihre Zahlungsinformationen",
    "LIMITS_UPGRADE": "Ihr Konto hat die Nutzungsbeschränkungen überschritten. Um diese Software weiter nutzen zu können, aktualisieren Sie bitte Ihren Tarif",
    "OPEN_BILLING": "Rechnung öffnen",
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Sie haben das Unterhaltungslimit überschritten. Der Hacker-Plan erlaubt nur 500 Unterhaltungen.",
      "INBOXES": "Sie haben das Posteingangslimit überschritten. Der Hacker-Plan unterstützt nur Website-Live-Chat. Weitere Posteingänge wie E-Mail, WhatsApp usw. erfordern einen kostenpflichtigen Plan.",
      "AGENTS": "Sie haben das Agentenlimit überschritten. Der Hacker-Plan erlaubt nur 2 Agenten.",
      "NON_ADMIN": "Bitte wenden Sie sich an Ihren Administrator, um den Plan zu aktualisieren und alle Funktionen weiter zu nutzen."
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Konto löschen",
      "NOTE": "Sobald Sie Ihr Konto löschen, werden alle Ihre Daten gelöscht.",
      "BUTTON_TEXT": "Konto löschen",
      "CONFIRM": {
        "TITLE": "Konto löschen",
        "MESSAGE": "Das Löschen Ihres Kontos ist unumkehrbar. Geben Sie unten Ihren Kontonamen ein, um zu bestätigen, dass Sie es dauerhaft löschen möchten.",
        "BUTTON_TEXT": "Löschen",
        "DISMISS": "Abbrechen",
        "PLACE_HOLDER": "Bitte geben Sie {accountName} zur Bestätigung ein"
      },
      "SUCCESS": "Konto zur Löschung markiert",
      "FAILURE": "Konto konnte nicht gelöscht werden, bitte versuchen Sie es erneut!",
      "SCHEDULED_DELETION": {
        "TITLE": "Konto zur Löschung geplant",
        "MESSAGE_MANUAL": "Dieses Konto ist für die Löschung am {deletionDate} geplant. Dies wurde von einem Administrator angefordert. Sie können die Löschung vor diesem Datum abbrechen.",
        "MESSAGE_INACTIVITY": "Dieses Konto ist aufgrund von Inaktivität für die Löschung am {deletionDate} geplant. Sie können die Löschung vor diesem Datum abbrechen.",
        "CLEAR_BUTTON": "Geplante Löschung abbrechen"
      }
    },
    "NEW_VERSION_AVAILABLE": "Eine neue Version ist verfügbar. Laden Sie die Seite neu, um die neuesten Updates zu erhalten.",
    "RELOAD_NOW": "Jetzt aktualisieren"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Drücken Sie zur Auswahl die Eingabetaste",
      "ENTER_TO_REMOVE": "Drücken Sie zum Entfernen die Eingabetaste",
      "NO_OPTIONS": "Liste ist leer",
      "NO_RESULT": "Keine Ergebnisse gefunden",
      "SELECT_ONE": "Eines wählen",
      "SELECT": "Auswählen"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Push-Benachrichtigungen",
    "MARK_ALL_DONE": "Alle als Erledigt markieren",
    "DELETE_TITLE": "Gelöscht",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Ungelesene Benachrichtigungen",
      "ALL_NOTIFICATIONS": "Alle Benachrichtigungen anzeigen",
      "LOADING_UNREAD_MESSAGE": "Ungelesene Benachrichtigungen werden geladen...",
      "EMPTY_MESSAGE": "Sie haben keine ungelesenen Benachrichtigungen"
    },
    "LIST": {
      "404": "Keine Benachrichtigungen",
      "LOADING_MESSAGE": "Benachrichtigungen werden geladen...",
      "TABLE_HEADER": [
        "Name",
        "Telefonnummer",
        "Konversationen",
        "Zuletzt kontaktiert"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Neue Konversation",
      "conversation_assignment": "Konversation zugewiesen",
      "assigned_conversation_new_message": "Neue Nachricht",
      "participating_conversation_new_message": "Neue Nachricht",
      "conversation_mention": "Erwähnung",
      "sla_missed_first_response": "SLA verpasst",
      "sla_missed_next_response": "SLA verpasst",
      "sla_missed_resolution": "SLA verpasst"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Verbinde neu...",
      "RECONNECT_SUCCESS": "Wiederverbunden"
    },
    "BUTTON": {
      "REFRESH": "Neu laden"
    },
    "CONNECTION_LOST": {
      "TITLE": "Verbindung verloren",
      "DESCRIPTION": "Der Server konnte nicht erreicht werden. Überprüfe deine Verbindung und versuche es erneut.",
      "RETRY": "Erneut versuchen"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Suchen oder springen zu",
    "SECTIONS": {
      "GENERAL": "Generell",
      "REPORTS": "Berichte",
      "CONVERSATION": "Konversation",
      "BULK_ACTIONS": "Massenaktionen",
      "CHANGE_ASSIGNEE": "Beauftragten ändern",
      "CHANGE_PRIORITY": "Priorität ändern",
      "CHANGE_TEAM": "Team wechseln",
      "SNOOZE_CONVERSATION": "Konversation stummschalten",
      "EXECUTE_MACRO": "Makro ausführen",
      "ADD_LABEL": "Label zur Konversation hinzufügen",
      "REMOVE_LABEL": "Label aus der Konversation entfernen",
      "SETTINGS": "Einstellungen",
      "AI_ASSIST": "AI-Assistent",
      "APPEARANCE": "Darstellung",
      "SNOOZE_NOTIFICATION": "Ungelesene Benachrichtigungen"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Zur Konversationsübersicht",
      "GO_TO_CONTACTS_DASHBOARD": "Zur Kontaktübersicht",
      "GO_TO_REPORTS_OVERVIEW": "Zur Berichtsübersicht",
      "GO_TO_CONVERSATION_REPORTS": "Gehen Sie zu Konversationsberichten",
      "GO_TO_AGENT_REPORTS": "Zu den Agentenberichten",
      "GO_TO_LABEL_REPORTS": "Zu den Label-Berichten",
      "GO_TO_INBOX_REPORTS": "Zu den Posteingangsberichten",
      "GO_TO_TEAM_REPORTS": "Zu den Teamberichten",
      "GO_TO_SETTINGS_AGENTS": "Zu den Agenten-Einstellungen",
      "GO_TO_SETTINGS_TEAMS": "Zu den Team Einstellungen",
      "GO_TO_SETTINGS_INBOXES": "Zu den Posteingangseinstellungen",
      "GO_TO_SETTINGS_LABELS": "Zu den Labeleinstellungen",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Zu den Einstellungen für vorgefertigte Antworten",
      "GO_TO_SETTINGS_APPLICATIONS": "Zu den Anwendungseinstellungen",
      "GO_TO_SETTINGS_ACCOUNT": "Zu den Kontoeinstellungen",
      "GO_TO_SETTINGS_PROFILE": "Zu Profileinstellungen",
      "GO_TO_NOTIFICATIONS": "Zu Benachrichtigungen",
      "ADD_LABELS_TO_CONVERSATION": "Label zur Konversation hinzufügen",
      "ASSIGN_AN_AGENT": "Einen Agent zuweisen",
      "AI_ASSIST": "AI-Assistent",
      "ASSIGN_PRIORITY": "Priorität zuweisen",
      "ASSIGN_A_TEAM": "Ein Team zuweisen",
      "EXECUTE_A_MACRO": "Ein Makro ausführen",
      "MUTE_CONVERSATION": "Konversation stummschalten",
      "UNMUTE_CONVERSATION": "Konversation entstummen",
      "REMOVE_LABEL_FROM_CONVERSATION": "Label aus der Konversation entfernen",
      "REOPEN_CONVERSATION": "Konversation wieder öffnen",
      "RESOLVE_CONVERSATION": "Konversation lösen",
      "SEND_TRANSCRIPT": "Ein E-Mail-Transkript senden",
      "SNOOZE_CONVERSATION": "Snooze-Konversation",
      "UNTIL_NEXT_REPLY": "Bis zur nächsten Antwort",
      "UNTIL_NEXT_WEEK": "Bis nächste Woche",
      "UNTIL_TOMORROW": "Bis morgen",
      "UNTIL_NEXT_MONTH": "bis zum nächsten Monat",
      "AN_HOUR_FROM_NOW": "bis in einer Stunde von jetzt an",
      "UNTIL_CUSTOM_TIME": "individuell",
      "CHANGE_APPEARANCE": "Aussehen ändern",
      "LIGHT_MODE": "Hell",
      "DARK_MODE": "Dunkel",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Ungelesene Benachrichtigungen"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Dashboard-App wird geladen..."
  },
  "COMMON": {
    "OR": "Oder",
    "CLICK_HERE": "hier klicken"
  }
}
